import React, { useEffect, useState } from 'react';
import { Box, Card, Typography, Breadcrumbs, Divider, Button, Skeleton } from '@mui/material';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Formik, Form } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useResponseHandler } from '../../../../../hooks/useResponseHandler';
// import formInitialValues from './formik/formInitialValues';
import validationSchema from './formik/validationSchema';
import servicesIaFormModel from './formik/servicesIaFormModel';
import { ServicesIaForm } from './components/forms/ServicesIaForm';
// import { editServiceIaStore, getServiceIaByIdStore } from '../../../../store/services-ia';
import { MessagesDrawerRight } from '../../../../../components/MessagesDrawerRight';
import { editServiceIaStore, getServiceIaByIdStore } from 'store/services-ia';
import formInitialValues from './formik/formInitialValues';
import { currencies } from 'commons/constants/currencies';

const aiProviders = [
  { value: 'OPENAI', label: 'OpenAI' },
  { value: 'GEMINI', label: 'Gemini' },
  { value: 'ANTHROPIC', label: 'Anthropic' },
  { value: 'DEEPSEEK', label: 'DeepSeek' },
  { value: 'XAI', label: 'xAI' },
];

const aiServiceTypes = [
  { value: 'CHAT', label: 'Chat' },
  { value: 'IMAGE', label: 'Imagen' },
  { value: 'AUDIO', label: 'Audio' },
  { value: 'EMBEDDING', label: 'Embedding' },
  { value: 'OCR', label: 'OCR' },
  { value: 'VIDEO', label: 'Video' },
];

export const EditServiciosIa = () => {
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const { handleResponse, ResponseComponents } = useResponseHandler();
  const { formId, formField } = servicesIaFormModel;
  const [dataErrors, setMsgErrors] = useState([]);

  const [initialValues, setInitialValues] = useState<any>(formInitialValues);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, [id]);

  const loadData = async () => {
    if (!id) return;
    setLoading(true);
    const response = await dispatch(getServiceIaByIdStore(id));
    if (response?.ok && response?.data) {
      const item = response.data;
      setInitialValues({
        provider: aiProviders.find((p) => p.value === item.provider) || undefined,
        serviceType: aiServiceTypes.find((s) => s.value === item.serviceType) || undefined,
        name: item.name,
        code: item.code,
        description: item.description || '',
        apiVersion: item.apiVersion || '',
        currency: currencies.find((c) => c.value === item.currency) || undefined,
        inputPrice: item.inputPrice || '',
        outputPrice: item.outputPrice || '',
        cachePrice: item.cachePrice || '',
        contextWindow: item.contextWindow || '',
        maxOutputTokens: item.maxOutputTokens || '',
        sortOrder: item.sortOrder || '',
      });
    } else {
      navigate('/manager/plataforma-ia/configuracion/servicios');
    }
    setLoading(false);
  };

  const handleSubmit = async (values: any, actions: any) => {
    if (!id) return;
    actions.setSubmitting(true);

    const mappedValues = {
      ...values,
      provider: values.provider?.value || values.provider,
      serviceType: values.serviceType?.value || values.serviceType,
      currency: values.currency?.value || values.currency,
    };

    const response = await dispatch(editServiceIaStore(id, mappedValues));

    await handleResponse(response, 'Servicio IA Actualizado Con Éxito', true);
    actions.setSubmitting(false);
  };

  if (loading)
    return (
      <Box sx={{ p: 4 }}>
        <Skeleton variant="rectangular" height={400} />
      </Box>
    );

  return (
    <Box sx={{ width: '100%' }}>
      <MessagesDrawerRight data={dataErrors} title={''} />
      {ResponseComponents}

      <Typography fontSize={25} color="textPrimary" sx={{ fontWeight: 700 }}>
        Editar Servicio IA
      </Typography>
      <Breadcrumbs aria-label="breadcrumb" sx={{ padding: 2 }}>
        <Typography color="textPrimary" sx={{ fontWeight: 700 }}>
          Manager
        </Typography>
        <Link color="inherit" to="/manager/plataforma-ia/configuracion/servicios">
          Listar Servicios
        </Link>
        <Typography color="textPrimary">Editar Servicio IA</Typography>
      </Breadcrumbs>

      <Divider sx={{ marginBottom: 3 }} />

      <Formik
        initialValues={initialValues}
        enableReinitialize
        validationSchema={validationSchema[0]}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting }) => (
          <Card
            sx={{
              mt: 2,
              p: 3,
              borderRadius: 2,
              boxShadow: '0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
            }}
          >
            <Form id={formId} autoComplete="off">
              <ServicesIaForm formField={formField} />

              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 4, gap: 2 }}>
                <Button
                  component={Link}
                  to="/manager/plataforma-ia/configuracion/servicios"
                  color="inherit"
                  sx={{ borderRadius: 2, textTransform: 'none' }}
                >
                  Cancelar
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={isSubmitting}
                  sx={{ borderRadius: 2, textTransform: 'none' }}
                >
                  Guardar Cambios
                </Button>
              </Box>
            </Form>
          </Card>
        )}
      </Formik>
    </Box>
  );
};
